import { render } from "./averageQulity.vue?vue&type=template&id=98935b74&scoped=true"
import script from "./averageQulity.vue?vue&type=script&lang=js"
export * from "./averageQulity.vue?vue&type=script&lang=js"

import "./averageQulity.vue?vue&type=style&index=0&id=98935b74&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98935b74"]])

export default __exports__